/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { Channel } from '../../common/types/types';

interface TestChannelAuthMutationProps {
    channel: Channel;
}

export default class TestChannelAuthMutation extends Relay.Mutation<TestChannelAuthMutationProps> {
    static propTypes = {
        channel: PropTypes.object.isRequired,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Channel {
                    organisation_id,
                    id,
                    activated,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {testChannelAuth}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on TestChannelAuthPayload {
                success,
                message,
                fetch {
                    id,
                    realId,
                    channel_id,
                    organisation_id
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel.id,
            organisation_id: this.props.channel.organisation_id,
        };
    }
}
